'use client';

import { Button } from '@common/components';
import { SvgAlignBack, SvgCheck } from '@common/icon';
import { useState } from 'react';

import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';

const UrlCopyRow = () => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    const url = new URL(
      DONATION_ROUTES.MARKET.pathname,
      window.location.origin,
    );
    await navigator.clipboard.writeText(url.href);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div className="flex items-start gap-12 border-b border-Gray-200 py-8">
      <span className="w-40 shrink-0 py-4 font-700 text-Gray-black typo-body4">
        URL
      </span>
      <div className="flex flex-1 flex-col gap-4">
        <Button
          dimensions="H40"
          theme="sub-fill"
          onClick={handleCopy}
          className={
            isCopied
              ? '!border-G-500 !bg-G-50 !text-G-600 transition-colors'
              : ''
          }
        >
          {isCopied ? (
            <>
              복사 완료
              <SvgCheck className="size-16 animate-[scale-in_0.2s_ease-out]" />
            </>
          ) : (
            <>
              링크 복사하기
              <SvgAlignBack className="size-16" />
            </>
          )}
        </Button>
        <p className="text-center font-600 text-Gray-550 typo-caption2">
          위 링크를 복사하여 포스팅에 포함해주세요
        </p>
      </div>
    </div>
  );
};

const BLOG_GUIDE = [
  { label: '제목', value: "'고향사랑기부제' + '키워드' + '웰로' 포함" },
  { label: '키워드', value: '답례품 추천, 연말정산, 세액공제 中 택1' },
  { label: '본문', value: '분량 공백 미포함 1,000자 이상' },
  { label: '사진', value: '기부 인증 포함 사진 5장 이상' },
  {
    label: '내용',
    items: [
      "1. '웰로' 장점 및 혜택 3가지 이상",
      "2. '고향사랑기부제' 5번 이상 언급",
      "3. '웰로' 5번 이상 언급",
    ],
  },
];

const INSTAGRAM_GUIDE = [
  { label: '계정 태그', value: '@wello.info 언급 필수' },
  { label: '해시태그', value: '#웰로 #웰로고향사랑기부제 #연말정산' },
  { label: '사진', value: '기부 인증 포함 사진 1장 이상' },
];

const BlogIcon = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
    <path
      d="M16.542 0C18.23 0.0 19.09 0.01 19.83 0.03L20.12 0.04C20.45 0.06 20.78 0.07 21.18 0.09C22.78 0.16 23.87 0.42 24.82 0.79C25.81 1.17 26.65 1.68 27.48 2.52C28.25 3.27 28.84 4.17 29.21 5.17C29.58 6.13 29.83 7.22 29.91 8.82C29.93 9.22 29.94 9.55 29.95 9.88L29.96 10.18C29.99 10.91 29.99 11.77 30.0 13.46L30.0 14.58V16.54C30.003 17.64 29.99 18.73 29.96 19.82L29.96 20.11C29.94 20.452 29.93 20.78 29.91 21.18C29.84 22.78 29.58 23.87 29.21 24.82C28.84 25.83 28.25 26.73 27.48 27.48C26.73 28.25 25.83 28.84 24.82 29.21C23.87 29.58 22.78 29.83 21.18 29.91L20.12 29.95L19.83 29.96C19.09 29.98 18.23 29.99 16.542 30.0L15.42 30.0H13.46C12.37 30.0 11.27 29.99 10.18 29.96L9.89 29.96C9.53 29.94 9.17 29.93 8.82 29.91C7.22 29.83 6.13 29.58 5.18 29.21C4.17 28.84 3.27 28.25 2.52 27.48C1.76 26.73 1.16 25.83 0.79 24.82C0.42 23.87 0.17 22.78 0.09 21.18L0.05 20.11L0.04 19.82C0.01 18.73 -0.0 17.64 0.0 16.54V13.46C-0.0 12.36 0.01 11.27 0.03 10.18L0.04 9.88C0.06 9.55 0.07 9.22 0.09 8.82C0.16 7.22 0.42 6.13 0.79 5.17C1.16 4.17 1.76 3.27 2.52 2.52C3.27 1.75 4.18 1.16 5.18 0.79C6.13 0.42 7.22 0.16 8.82 0.09C9.22 0.07 9.55 0.06 9.89 0.04L10.18 0.04C11.27 0.01 12.36 -0.0 13.46 0.0L16.542 0ZM22.71 5.08V24.45H24V5.08H22.71ZM6 6.62V23.16H8.91V22.53C9.96 23.25 11.23 23.67 12.6 23.67C16.2 23.67 19.12 20.76 19.12 17.16C19.12 13.56 16.2 10.65 12.6 10.65C11.23 10.65 9.96 11.07 8.91 11.791V6.62H6ZM12.6 13.47C14.64 13.47 16.29 15.13 16.29 17.16C16.29 19.2 14.64 20.85 12.6 20.85C10.57 20.85 8.92 19.2 8.92 17.16C8.92 15.13 10.57 13.47 12.6 13.47Z"
      fill="#32343A"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
    <path
      d="M16.542 0C18.23 0.0 19.09 0.01 19.83 0.03L20.12 0.04C20.45 0.06 20.78 0.07 21.18 0.09C22.78 0.16 23.87 0.42 24.82 0.79C25.81 1.17 26.65 1.68 27.48 2.52C28.25 3.27 28.84 4.17 29.21 5.17C29.58 6.13 29.83 7.22 29.91 8.82C29.93 9.22 29.94 9.55 29.95 9.88L29.96 10.18C29.99 10.91 29.99 11.77 30.0 13.46L30.0 14.58V16.54C30.003 17.64 29.99 18.73 29.96 19.82L29.96 20.11C29.94 20.452 29.93 20.78 29.91 21.18C29.84 22.78 29.58 23.87 29.21 24.82C28.84 25.83 28.25 26.73 27.48 27.48C26.73 28.25 25.83 28.84 24.82 29.21C23.87 29.58 22.78 29.83 21.18 29.91L20.12 29.95L19.83 29.96C19.09 29.98 18.23 29.99 16.542 30.0L15.42 30.0H13.46C12.37 30.0 11.27 29.99 10.18 29.96L9.89 29.96C9.53 29.94 9.17 29.93 8.82 29.91C7.22 29.83 6.13 29.58 5.18 29.21C4.17 28.84 3.27 28.25 2.52 27.48C1.76 26.73 1.16 25.83 0.79 24.82C0.42 23.87 0.17 22.78 0.09 21.18L0.05 20.11L0.04 19.82C0.01 18.73 -0.0 17.64 0.0 16.54V13.46C-0.0 12.36 0.01 11.27 0.03 10.18L0.04 9.88C0.06 9.55 0.07 9.22 0.09 8.82C0.16 7.22 0.42 6.13 0.79 5.17C1.16 4.17 1.76 3.27 2.52 2.52C3.27 1.75 4.18 1.16 5.18 0.79C6.13 0.42 7.22 0.16 8.82 0.09C9.22 0.07 9.55 0.06 9.89 0.04L10.18 0.04C11.27 0.01 12.36 -0.0 13.46 0.0L16.542 0ZM15.0 7.5C13.01 7.5 11.1 8.29 9.7 9.7C8.29 11.103 7.5 13.01 7.5 15.0C7.5 16.99 8.29 18.9 9.7 20.3C11.1 21.71 13.01 22.5 15.0 22.5C16.99 22.5 18.9 21.71 20.3 20.3C21.71 18.9 22.5 16.99 22.5 15.0C22.5 13.01 21.71 11.103 20.3 9.7C18.9 8.29 16.99 7.5 15.0 7.5ZM15.0 10.5C15.591 10.5 16.18 10.62 16.72 10.842C17.27 11.068 17.76 11.4 18.18 11.82C18.6 12.235 18.93 12.731 19.16 13.28C19.384 13.82 19.5 14.408 19.5 15.0C19.5 15.59 19.38 16.175 19.16 16.721C18.93 17.267 18.601 17.76 18.18 18.181C17.77 18.6 17.27 18.93 16.72 19.16C16.18 19.38 15.59 19.5 15.0 19.5C13.81 19.5 12.66 19.03 11.82 18.18C10.98 17.34 10.5 16.19 10.5 15.0C10.5 13.81 10.98 12.66 11.82 11.82C12.66 10.97 13.81 10.5 15.0 10.5M22.88 5.25C22.38 5.25 21.9 5.45 21.55 5.8C21.2 6.15 21.0 6.63 21.0 7.12C21.0 7.62 21.2 8.099 21.55 8.45C21.9 8.8 22.38 9.0 22.88 9.0C23.37 9.0 23.85 8.8 24.202 8.45C24.55 8.099 24.75 7.62 24.75 7.12C24.75 6.63 24.55 6.15 24.202 5.8C23.85 5.45 23.37 5.25 22.88 5.25Z"
      fill="#32343A"
    />
  </svg>
);

const PointBadge = ({ amount }: { amount: string }) => (
  <div className="flex w-180 flex-col items-center justify-center gap-4 rounded-xlarge bg-[#deb270c4] px-20 py-16">
    <div className="flex items-center gap-8">
      <Image
        src="/assets/pngs/coin2.png"
        alt="웰포인트"
        width={24}
        height={24}
      />
      <span className="font-800 text-Gray-black typo-body3">웰포인트</span>
    </div>
    <span className="font-800 text-Gray-black typo-h4">{amount}</span>
  </div>
);

const GuideRow = ({
  label,
  value,
  items,
}: {
  label: string;
  value?: string;
  items?: string[];
}) => (
  <div className="flex items-start gap-12 border-b border-Gray-200 py-8">
    <span className="w-40 shrink-0 font-700 text-Gray-black typo-body4">
      {label}
    </span>
    <div className="flex flex-1 flex-col gap-2 font-600 text-Gray-600 typo-caption1">
      {value && <p>{value}</p>}
      {items?.map((item) => (
        <p key={item}>{item}</p>
      ))}
    </div>
  </div>
);

const InstagramGuideRow = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => (
  <div className="flex items-start gap-12 border-b border-Gray-200 py-8">
    <span className="w-52 shrink-0 font-700 text-Gray-black typo-body4">
      {label}
    </span>
    <p className="flex-1 font-600 text-Gray-600 typo-caption1">{value}</p>
  </div>
);

export const ReviewGuide = () => (
  <section className="flex flex-col items-center bg-[#e4302c] px-32 py-60">
    <div className="flex w-full max-w-[375px] flex-col items-center gap-20">
      <p className="text-center font-800 text-Gray-white typo-h4">
        포토 후기 작성 방법
        <br />
        알려드릴게요!
      </p>
      <p className="text-center font-600 text-Gray-25 typo-body3">
        SNS 포스팅 가이드에 맞춰 작성해주시면
        <br />
        포인트가 적립됩니다!
      </p>

      <div className="flex w-full flex-col items-center gap-24 rounded-large bg-Gray-white px-32 py-40">
        <div className="flex items-center gap-8">
          <BlogIcon />
          <span className="font-800 text-Gray-900 typo-body3">
            네이버 블로그 후기 작성법
          </span>
        </div>
        <div className="flex w-full flex-col">
          {BLOG_GUIDE.map((item) => (
            <GuideRow key={item.label} {...item} />
          ))}
          <UrlCopyRow />
        </div>
        <div className="flex flex-col items-center gap-8">
          <PointBadge amount="10,000원" />
          <p className="text-center font-700 text-Gray-black typo-body2">
            네이버 블로그는
            <br />
            1만원 웰포인트 지급!
          </p>
        </div>
      </div>

      <div className="flex w-full flex-col items-center gap-20 rounded-large bg-Gray-white px-24 py-40">
        <div className="flex items-center gap-8">
          <InstagramIcon />
          <span className="font-800 text-Gray-900 typo-body3">
            인스타그램 피드 후기 작성법
          </span>
        </div>
        <div className="flex w-full flex-col">
          {INSTAGRAM_GUIDE.map((item) => (
            <InstagramGuideRow key={item.label} {...item} />
          ))}
        </div>
        <div className="flex flex-col items-center gap-8">
          <PointBadge amount="3,000원" />
          <p className="text-center font-700 text-Gray-black typo-body2">
            인스타그램 피드는
            <br />
            3천원 웰포인트 지급!
          </p>
        </div>
        <p className="font-400 text-R-500 typo-caption1">
          *인스타그램 게시물(피드) 후기만 지급됩니다.
          <br />
          *비공개 계정일 경우, 웰포인트가 지급되지 않습니다.
        </p>
      </div>
    </div>
  </section>
);
